import { memo, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { projectHelper, userHelper } from '../../common/src/helpers'
import { AMPLITUDE_ACTION_TYPES, dispatchEvent } from '../../common/src/eventTracking/amplitudeEvents'
import { useOrganizedUsersOptions } from '../../hooks/useUsersOption'
import { UserPanel } from '../users/panels/UserPanel'
import { useTranslation } from 'react-i18next'

export const OwnerPanel = memo(({ user, project, onChange, onDismiss, ...rest }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  
  const minusUsers = useMemo(() => {
    return [user]
  }, [user])
  const options = useOrganizedUsersOptions({
    project,
    minusUsers,
  })

  const onSelectUserClosing = useCallback(
    user => {
      const email = user ? userHelper.getEmail(user) : ''
      dispatch(dispatchEvent(AMPLITUDE_ACTION_TYPES.DELEGATE_ITEM))
      onChange(email)
      onDismiss()
    },
    [onChange, onDismiss, dispatch]
  )

  // Check if project is restricted - hide external access for all users on items
  const isProjectRestricted = projectHelper.isRestricted(project)
  const shouldHideExternalAccess = isProjectRestricted

  return (
    <UserPanel
      headerText={t('item_detail.owner_panel_text_field_placeholder')}
      onDismiss={onDismiss}
      user={user}
      options={options}
      onSelectUser={onSelectUserClosing}
      selectedUserHeader={t('users.assigned_to')}
      textFieldPlaceholder={t('item_detail.owner_panel_text_field_placeholder')}
      invitationIconProps={{ title: t('item_detail.owner_panel_text_field_placeholder') }}
      clearText={t('users.clear_owner')}
      project={project}
      hideEmailInput={shouldHideExternalAccess}
      hideUserGroups={shouldHideExternalAccess}
      {...rest}
    />
  )
})
